export const AUTHENTICATION = 'authentication'
export const INVALID_UUIDS = 'invalid_uuids'
export const MISSING_ENTITY = 'missing_entity'
export const PARTIAL_INVALID_UUIDS = 'partial_invalid_uuids'
export const UNKNOWN = 'unknown'
export const VALIDATION = 'validation'

export default {
    AUTHENTICATION,
    INVALID_UUIDS,
    MISSING_ENTITY,
    PARTIAL_INVALID_UUIDS,
    UNKNOWN,
    VALIDATION
}
